export const METAMODELO = {
    lei: "LEI Nº 10.861, DE 14 DE ABRIL DE 2004",
    notaTecnica: "NOTA TÉCNICA INEP/DAES/CONAES Nº 65, DE 09 DE OUTUBRO DE 2014",
    eixos: [
        {
            numero: 1,
            nome: "Planejamento e Avaliação Institucional",
            dimensoes: [
                {
                    numero: 8,
                    nome: "Planejamento e Avaliação",
                    descricao: "Abrange a atuação da Comissão Própria de Avaliação (CPA) e de suas subcomissões nos campi (SPAs) nos últimos ciclos, considerando procedimentos e ferramentas para envolvimento da comunidade acadêmica no diagnóstico, compartilhamento de resultados e propositura de ações melhorias (institucional, campi e cursos)."
                }
            ]
        },
        {
            numero: 2,
            nome: "Desenvolvimento Institucional",
            dimensoes: [
                {
                    numero: 1,
                    nome: "Missão e Plano de Desenvolvimento Institucional",
                    descricao: "Abrange a eficiência dos procedimentos e ferramentas de planejamento (institucional e nos campi), para delineamento e monitoramento de metas e objetivos, de forma a fortalecer continuamente a missão da instituição."
                },
                {
                    numero: 3,
                    nome: "Responsabilidade Social da Instituição",
                    descricao: "Abrange a atuação (institucional, campi ou cursos) para impactar bi desenvolvimento socioeconômico local e regional, contribuindo para uma sociedade mais inclusiva, sustentável e consciente sobre a defesa do meio ambiente, da memória e do patrimônio artístico e cultural."
                }
            ]
        },
        {
            numero: 3,
            nome: "Políticas Acadêmicas",
            dimensoes: [
                {
                    numero: 2,
                    nome: "Políticas para o Ensino, a Pesquisa e a Extensão",
                    descricao: "Abrange os procedimentos mantidos para estímulo à pesquisa, extensão e inovação: apoio técnico/gerencial a projetos, suporte a grupos e núcleos, facilidade para formação de parcerias e obtenção de fomento e bolsas. Também abrange a concepção pedagógica (PPC) e de funcionamento dos cursos para a excelência acadêmica, incluindo metodologias de aprendizagem pelo corpo docente, adequação e atualização dos conteúdos às áreas dos cursos, oferta de atividades extracurriculares ou complementares."
                },
                {
                    numero: 4,
                    nome: "Comunicação com a Sociedade",
                    descricao: "Abrange a eficiência da linguagem e dos canais de comunicação utilizados (institucional, campi ou cursos), para a devida apropriação de informações de interesse da comunidade interna (ex.: aproximando cursos, setores, campi ou reitoria) ou da comunidade externa (ex.: oferta de cursos, produção acadêmica e resultados instucionais)."
                },
                {
                    numero: 9,
                    nome: "Política de Atendimento aos Discentes",
                    descricao: "Abrange a eficiência de procedimentos envolvendo ações ou programas para permanência e êxito de estudantes (serviços de atendimento para orientação e acompanhamento acadêmico, serviços de assistência pedagógica e estudantil, atendimento de coordenações de curso, monitoria ou tutoria acadêmica, auxílios financeiros, ações culturais, desortivas e de lazer para estudantes e similares)."
                }
            ]
        },
        {
            numero: 4,
            nome: "Políticas de Gestão",
            dimensoes: [
                {
                    numero: 5,
                    nome: "Políticas de Pessoal",
                    descricao: "Abrange as políticas de pessoal, de carreiras do corpo docente e corpo técnico administrativo, seu aperfeiçoamento, seu desenvolvimento profissional e de suas condições de trabalho, incluindo o relacionamento interpessoal (institucional, campi, cursos e setores)."
                },
                {
                    numero: 6,
                    nome: "Organização e Gestão da Instituição",
                    descricao: "Abrange como as diversas instâncias são geridas (institucional, campi, cursos), podendo englobar pró-reitorias, direções ou coordenações específicas. Também abrange, em especial, o conselho superior da instituição (CONSUPER), os conselhos diretores dos campi, conselhos e órgãos colegiados de pró-reitorias e de cursos (NDE e colegido), quanto ao desempenho de suas atuações, de forma a atender equitativamente os diversos segmentos da comunidade institucional em seus processos decisórios."
                },
                {
                    numero: 10,
                    nome: "Sustentabilidade Financeira",
                    descricao: "Abrange como ocorre a oferta de custeio e investimentos em ensino, pesquisa, extensão e inovação, em conformidade com o planejamento institucional, especialmente sobre o que consta no Plano de Desenvolvimento Institucional (PDI) vigente."
                }
            ]
        },
        {
            numero: 5,
            nome: "Infraestrutura Física",
            dimensoes: [
                {
                    numero: 7,
                    nome: "Infraestrutura Física",
                    descricao: "Abrange a qualidade e suficiência da infraestutura física (institucional, campi e cursos) como salas de aula, laboratórios e seus equipamentos; espaços de convivência e de lazer; restaurante; espaços de estudo extraclasse; segurança, disponibilidade, limpeza e manutenção de espaços; biblioteca, acervo e serviços; acessibilidade para pessoas com deficiência."
                }
            ]
        }
    ],

    getEixo: function (numero, comoObjeto = false) {
        let eixoEncontrado = METAMODELO.eixos.find(eixo => eixo.numero === numero);

        if (comoObjeto)
            return eixoEncontrado;

        //retorna como string
        return `[EIXO ${eixoEncontrado.numero}] ${eixoEncontrado.nome}`;
    },

    getDimensao: function (numero, comoObjeto = false) {
    let dimensaoEncontrada;
    let eixoEncontrado;

    for (const eixo of METAMODELO.eixos) {
        const dimensao = eixo.dimensoes.find(d => d.numero === numero);
        if (dimensao) {
            eixoEncontrado = eixo;
            dimensaoEncontrada = dimensao;
            break;
        }
    }

    if (!dimensaoEncontrada) return null;

    if (comoObjeto)
        return dimensaoEncontrada;

    return `[EIXO ${eixoEncontrado.numero}] ${eixoEncontrado.nome} / [DIMENSÃO ${dimensaoEncontrada.numero}] ${dimensaoEncontrada.nome}`;
    },


    getEixos: function() {
        return METAMODELO.eixos.map((eixo) => ({
            label: `[EIXO ${eixo.numero}] ${eixo.nome}`,
            value: eixo.numero,
        }));
    },

    getDimensoes: function (numeroEixo) {
        const dimensoes = [];

        // Encontre o eixo correspondente ao número fornecido
        const eixoEncontrado = METAMODELO.eixos.find(eixo => eixo.numero === numeroEixo);

        if (eixoEncontrado) {
            // Se o eixo foi encontrado, adicione suas dimensões às opções
            dimensoes.push(...eixoEncontrado.dimensoes);
        }

        return dimensoes;
    },

    getTitleOption: function () {
        const options = METAMODELO.eixos.flatMap((eixo) => {
            return eixo.dimensoes.map((dimensao) => ({
              label: `[EIXO ${eixo.numero}] ${eixo.nome} / [DIMENSÃO ${dimensao.numero}] ${dimensao.nome}`,
              value: `[EIXO ${eixo.numero}] ${eixo.nome} / [DIMENSÃO ${dimensao.numero}] ${dimensao.nome}`,
            }));
        });
        return options;
    },

    getEixoByTitulo: function (titulo) {
        const parts = titulo.split(" / ");
        if (parts.length !== 2) {
            return null;
        }

        const eixoPart = parts[0]; // Parte correspondente ao eixo

        const eixoEncontrado = METAMODELO.eixos.find(eixo => {
            const eixoTitulo = `[EIXO ${eixo.numero}] ${eixo.nome}`;
            return eixoTitulo === eixoPart;
        });

        return eixoEncontrado;
    },

    getDimensaoByTitulo: function (titulo) {
    for (const eixo of METAMODELO.eixos) {
        const dimensao = eixo.dimensoes.find(d => {
            const dimensaoTitulo = `[EIXO ${eixo.numero}] ${eixo.nome} / [DIMENSÃO ${d.numero}] ${d.nome}`;
            return dimensaoTitulo === titulo;
        });
        if (dimensao) {
            return dimensao;
        }
    }
    return null;
    },


}

export const TIPOS_NIVEIS_ORGANIZACIONAIS = {
    niveis:[
        {'nivel': 'INSTITUCIONAL'},
        {'nivel': 'CAMPUS'},
        {'nivel': 'CURSO'},
        {'nivel': 'DISCIPLINA'},
        {'nivel': 'SETOR'}
    ],

    getNivelOption: function () {
        const options = TIPOS_NIVEIS_ORGANIZACIONAIS.niveis.map((nivel) => ({
              label: `${nivel.nivel}`,
              value: `${nivel.nivel}`,
        }));
        return options;
    },
};
